// lib
import React from 'react';
import { Icon } from 'antd';

// container
import Home from '../containers/Welcome/Home'

export default {
  path: '/welcome',
  sidebar: {
    // TODO x-ray 更换icon
    icon: <Icon type="pie-chart" />,
    title: <span>引导页</span>,
  },
  routes: [
    {
      path: '/home',
      sidebar: {
        // TODO x-ray 确认是否需要hide
        hide: false,
        title: <span>引导页面</span>,
      },
      component: Home,
    },
  ]
};



// WEBPACK FOOTER //
// ./src/routes/welcome.jsx